import React, {useState, useEffect, useContext} from "react";
import NotificationModalBooking from "../../../containers/Notifications/modals/Notification.modal.booking";
import {useAPI} from "../../../hooks/useAPI";
import {API_Organization} from "../../../api/organization";
import {observer, useLocalObservable} from "mobx-react";
import SocketStore from "../../../stores/socket.store";
import {AuthContext} from "../../../context/AuthContext";
import {API_VerificationCenter} from "../../../api/verifcationCenter";

const NotificationsModalOrganization = observer((props: { id?: string, setModal: any, getData: any }) => {
    const {APIRequest} = useAPI()
    const {token} = useContext(AuthContext)
    const store = useLocalObservable(() => ({
        data: null,
        setData: (data) => store.data = data
    }))

    const getData = async () => {
        const errorClose = (message) => {
            // props.setModal(null)
            // alert(message)
        }
        await APIRequest(API_Organization.notifications.getNotificationById(token.userId,props.id))
            .then(res => {
                res.status === 200
                    ? store.setData({...res?.body?.data, info: res?.body?.data?.info[0]})
                    : errorClose(res.message)
            })
    }

    const onDisagree = async () => {
        changeStatus("Ожидание")
        props.setModal(null)
        props.getData()
    }

    const changeStatus: (string: string, callback?: any) => void = async (status, callback) => {
        if (store?.data?.id) {
            store.setData({...store.data, status})
            await APIRequest(API_Organization.notifications.changeStatus(token.userId, store?.data?.id), {status})
            SocketStore.addListeners(socket => socket.emit('updateModal', "VerCenter"))
            SocketStore.addListeners(socket => socket.emit('updatePage', "VerCenter"))
            SocketStore.addListeners(socket => socket.emit('updateVerCenter', "VerCenter"))
            callback && callback()
        }

    }
    const agree = async () => {
        changeStatus("Принять")
        props.setModal(null)
        props.getData()

    }

    const button = (status?: "Ожидание" | "В работе" | "Согласовано" | "Одобрено", id?: string) => {
        let buttons = []

        const disagree = {text: "Отклонить", color: 'red', onClick: _ => onDisagree()}
        const confirm = {text: "Принять", onClick: _ => agree()}

        if (status === "Ожидание") buttons = [disagree]
        if (status === "В работе") buttons = [disagree]
        if (status === "Одобрено") buttons = [disagree, confirm]

        return buttons
    }

    const sockets = (socket) => {
        socket.on('updateModal', () => {
            getData()
        })
    }
    const deleteModal = () => {
        props.setModal(null)
        props.getData()
    }

    useEffect(() => {
        getData()
        SocketStore.addListeners(sockets)
        SocketStore.addListeners(socket => socket.emit('updateModal', token.userId))

    }, [])

    return (
        <NotificationModalBooking deleteModal={deleteModal} button={button} data={store.data} isOpen={true}/>
    )
})


export default NotificationsModalOrganization;
